// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eZzK_","avatar":"style_avatar__Awpd4","email":"style_email__bQPHQ","recognized":"style_recognized__tEzEa","check":"style_check__jYl6i"};